class API {
  constructor() {
    this.API_URL = "https://" + process.env.VUE_APP_API_HOST;
    // this.API_URL = "http://" + process.env.VUE_APP_API_HOST;
  }

  async getCompanySite() {
    const site = await window.localStorage.getItem("site");
    const company = await window.localStorage.getItem("company");
    return "/" + company + "/" + site;
  }

  async getUrl(url = "", queryString = "", includeCompany = false) {
    this.token = await window.localStorage.getItem("token");
    this.companyString = await this.getCompanySite();
    let rawUrl = url + (includeCompany ? this.companyString : "") + queryString;
    const response = await fetch(this.API_URL + rawUrl, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.token,
      },
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }

  async get(url = "") {
    this.token = await window.localStorage.getItem("token");
    const response = await fetch(this.API_URL + url, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.token,
      },
    });

    if (response.status == 401) {
      window.localStorage.clear();
      window.location.reload();
    } else if (response.status != 200 && response.status != 201) {
      throw "Server error: Error code is " + response.status;
    }
    return response.json(); // parses JSON response into native JavaScript objects
  }

  async post(url = "", data = {}) {
    this.token = await window.localStorage.getItem("token");
    const response = await fetch(this.API_URL + url, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.token,
      },
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });

    if (response.status == 401) {
      window.localStorage.clear();
      window.location.reload();
    } else if (response.status != 200 && response.status != 201) {
      throw "Server error: Error code is " + response.status;
    }

    return response.json(); // parses JSON response into native JavaScript objects
  }

  async login(email, password) {
    let result = await api.post("/api/user/login", { user: email, password: password });
    if (result === "user not found") {
      throw { email: "not found" };
    } else if (result === "unauthorized") {
      throw { email: "unauthorized" };
    }
    return result;
  }

  async getSiteToken(siteID) {
    let result = await api.post("/api/web/store", { key: siteID });
    return result;
  }

  async loadTheme(theme) {
    let themes = Object.keys(theme);
    themes.map((colour) => {
      if (theme[colour] != null) {
        document.querySelector(":root").style.setProperty(colour, theme[colour]);
      }
    });
  }

  async getSite(routeParam) {
    this.errors = {};
    try {
      // await window.localStorage.clear();
      //let result = await api.getSiteToken('"' + this.$route.params.id + '"');
      let result = await api.getSiteToken('"' + routeParam + '"');
      if (result.error) {
        return false;
      }
      await window.localStorage.setItem("token", result.jwt_token);

      if (result.settings[result.site].delivery_options.includes("future-pickup")) {
        await window.localStorage.setItem("futurePickup", true);
      }
      //const company = await api.get('/api/company/get_pos/"' + result.company + '"');
      await window.localStorage.setItem("company", result.company);
      await window.localStorage.setItem("companyName", result.name);
      await window.localStorage.setItem("site", result.site);
      await window.localStorage.setItem("station", result.jwt_token);
      await window.localStorage.setItem("shops", JSON.stringify(result.settings));
      this.loadTheme(result.theme);

      this.$.appContext.config.globalProperties.token = result.jwt_token;

      /* set the global JWT token */
      this.$store.dispatch("setToken", result.jwt_token);
      this.$store.commit("setWebStoreMutation", true);
      //this.$router.push({ path: '/store/' + this.$route.params.id });
      //await this.$store.dispatch('getAllData')
    } catch (error) {
      Object.keys(error).map((code) => {
        this.errors[code] = [error[code]];
      });
    }
    return true;
  }

  async videoUpload(url = "", data = {}) {
    this.token = await window.localStorage.getItem("token");
    let video = new FormData();
    video.append("video", data);
    try {
      const response = await fetch(this.API_URL + url, {
        method: "post",
        headers: {
          //   "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + this.token,
        },
        body: video, // body data type must match "Content-Type" header
      });

      if (response.status != 200 && response.status != 201) {
        throw "Server error: Error code is " + response.status;
      }

      return response.json();
    } catch (error) {
      console.log(error);
    }
  }

  async searchAccounts(query) {
    return await api.getUrl("/api/search_accounts", '?group=true&start_key=["' + query + '"]&end_key=["' + query + '\ufff0"]', true);
  }

  async searchVouchers(query) {
    return await api.getUrl("/api/search_vouchers", '?group=true&start_key=["' + query + '"]&end_key=["' + query + '\ufff0"]', true);
  }

  async getVoucher(id) {
    return await api.getUrl("/api/get_voucher", '?keys=["' + id + '"]', true);
  }

  async signup(name, email, password, company) {
    let result = await api.post("/api/user/signup", { name: name, user: email, password: password, company: company });
    return result;
  }

  async add_site(site, company, site_name) {
    let result = await api.post("/api/company/add_site/" + company, { site: site, site_name: site_name });
    return result;
  }

  async validate(token) {
    let result = await api.post("/api/user/validate", { token: token });
    return result;
  }

  async add_company(company, slug, tz, user_email) {
    let result = await api.post("/api/company/add", { company_name: company, timezone: tz, company: slug, user_email: user_email });
    return result;
  }

  async add_device_code(data) {
    let result = await api.post("/api/device/code/add", data);
    return result;
  }

  async device_login(data) {
    return await api.post("/api/device/login", { code: data });
  }

  async add_cogs_doc(company, doc) {
    let result = await api.post("/api/company/cogs/save_doc/" + company, { doc: doc });
    return result;
  }

  async get_stations(company) {
    let result = await api.get("/api/company/get_stations/" + company);
    return result;
  }

  async get_suppliers(company) {
    let result = await api.get("/api/company/cogs/get_suppliers/" + company + "?reduce=true&group_level=2");
    return result.rows;
  }

  async search_suppliers(company, supplier) {
    let result = await api.get("/api/company/cogs/get_suppliers/" + company + "?reduce=false&key=" + supplier);
    return result.rows;
  }

  async search_categories(company, category) {
    let result = await api.get("/api/company/cogs/get_base_recipes/" + company + "?reduce=false&start_key=[" + category + "]&end_key=[" + category + ",{}]");
    return result.rows;
  }

  async get_products(company) {
    let result = await api.get("/api/company/cogs/get_products/" + company);
    return result.rows;
  }

  async get_uom(company) {
    let result = await api.get("/api/company/cogs/get_uom/" + company + "?reduce=true&group=true");
    return result.rows;
  }

  async get_base_recipes(company) {
    let result = await api.get("/api/company/cogs/get_base_recipes/" + company + "?reduce=false");
    return result.rows;
  }

  async get_menu_recipes(company) {
    let result = await api.get("/api/company/cogs/get_menu_recipes/" + company + "?reduce=false");
    return result.rows;
  }

  async get_recipe_categories(company) {
    let result = await api.get("/api/company/cogs/get_base_recipes/" + company + "?reduce=true&group_level=1");
    return result.rows;
  }

  async get_pos_categories(company, site) {
    let result = await api.get("/api/categories/get/" + company + "/" + site);
    return result.rows;
  }

  async get_pos_products(company, site) {
    let result = await api.get("/api/products/get/" + company + "/" + site);
    return result.rows;
  }

  async get_sales_payment_data(startDate, endDate, company, site) {
    let result = await api.get("/api/reports/payments/" + company + "_" + site + '?group=true&group_level=2&start_key=["' + startDate + '"]&end_key=["' + endDate + '"]');
    return result.rows;
  }

  async get_sales_data(company, site, startDate, endDate) {
    let result = await api.get("/api/reports/sales/" + company + "_" + site + '?reduce=true&group_level=1&start_key=["' + startDate + '"]&end_key=["' + endDate + '"]');
    return result.rows;
  }

  async get_stacked_data(company, site, startDate, endDate) {
    let result = await api.get("/api/reports/sales/" + company + "_" + site + '?reduce=true&group_level=2&start_key=["' + startDate + '"]&end_key=["' + endDate + '"]');
    return result.rows;
  }

  async get_stacked_count(company, site, startDate, endDate) {
    let result = await api.get("/api/reports/count/" + company + "_" + site + '?reduce=true&group_level=2&start_key=["' + startDate + '"]&end_key=["' + endDate + '"]');
    return result.rows;
  }

  async get_products_stacked_data(company, site, startDate, endDate) {
    let result = await api.get("/api/reports/sales/" + company + "_" + site + '?reduce=true&group_level=3&start_key=["' + startDate + '"]&end_key=["' + endDate + '"]');
    return result.rows;
  }

  async get_products_stacked_count(company, site, startDate, endDate) {
    let result = await api.get("/api/reports/count/" + company + "_" + site + '?reduce=true&group_level=3&start_key=["' + startDate + '"]&end_key=["' + endDate + '"]');
    return result.rows;
  }

  async get_sales_total(company, site, startDate, endDate) {
    let result = await api.get("/api/reports/sales/" + company + "_" + site + '?reduce=true&group_level=0&start_key=["' + startDate + '"]&end_key=["' + endDate + '"]');
    return result.rows;
  }

  async get_sales_timeframe(company, site, days) {
    let result = await api.post("/api/reports/timeframe/sales/" + company + "/" + site, { days: days });
    return result;
  }

  async get_count_timeframe(company, site, days) {
    let result = await api.post("/api/reports/timeframe/count/" + company + "/" + site, { days: days });
    return result;
  }

  async get_product_count(company, site, startDate, endDate) {
    let result = await api.get("/api/reports/count/" + company + "_" + site + '?reduce=true&group_level=1&start_key=["' + startDate + '"]&end_key=["' + endDate + '"]');
    return result.rows;
  }

  async get_count_total(company, site, startDate, endDate) {
    let result = await api.get("/api/reports/count/" + company + "_" + site + '?reduce=true&group_level=0&start_key=["' + startDate + '"]&end_key=["' + endDate + '"]');
    return result.rows;
  }

  async save_company_settings(company, key, value) {
    let result = await api.post("/api/company/settings/" + company, { key: key, value: value });
    return result;
  }

  async getModifierSets(company, site) {
    const result = await api.get("/api/modifiersets/get/" + company + "/" + site + "?include_docs=false");
    return result.rows;
  }

  async email_password_reset(email) {
    let result = await api.post("/api/user/reset", { email: email });
    return result;
  }

  async resetPassword(email) {
    return await api.post("/api/enduser/reset", {
      email: email,
      db: window.localStorage.getItem("company") + "_users",
    });
  }

  async updatePass(token, password) {
    return await api.post("/api/enduser/update_pass", { token: token, password: password });
  }

  async reset_password(password) {
    let result = await api.post("/api/user/update_pass", password);
    return result;
  }

  async set_password(password) {
    let result = await api.post("/api/user/set_pass", password);
    return result;
  }

  async get_floor_plan(company, site) {
    let result = await api.get("/api/get_floorplans/" + company + "/" + site);
    return result.rows[0].value;
  }

  async get_enduser(company) {
    let result = await api.get("/api/enduser/get_user/" + company + "?reduce=true&group_level=0");
    return result.rows[0].value;
  }

  async get_enduser_orders(company, desending, limit, skip) {
    let result = await api.get("/api/enduser/get_user_orders/" + company + "?descending=" + desending + "&limit=" + limit + "&skip=" + skip);
    return result;
  }

  async get_station_float(company, site, station, total = false) {
    if (total) {
      return await api.get("/api/station/float/" + company + "/" + site + "/" + station + '?reduce=true&group=true&keys=["' + station + '"]');
    } else {
      return await api.get("/api/station/float/" + company + "/" + site + "/" + station + '?reduce=false&limit=7&keys=["' + station + '"]&include_docs=true');
    }
  }

  async get_user_orders(company, ids) {
    let result = await api.post("/api/enduser/get_orders/" + company, ids);
    return result;
  }

  async get_users(company) {
    let result = await api.get('/api/company/get_users/["' + company + '"]');
    return result.rows;
  }

  async add_new_user(company, u) {
    let result = await api.post("/api/company/new_user/" + company, { name: u.name, user: u.user, roles: u.roles });
    return result;
  }

  async get_enduser_points(company) {
    let result = await api.get("/api/enduser/get_points/" + company);
    return result;
  }

  async integrate_with_xero(company) {
    let result = await api.get("/api/company/initialise_xero_connection/" + company);
    this.save_company_settings(company, "xero_linked", true);
    return result;
  }

  //this needs to tested and debugged
  async initilise_stripe_connect(company) {
    let result = await api.get("/api/company/initialise_stripe_connection/" + company);
    return result;
  }

  async get_xero_tax_types(company) {
    let result = await api.get("/api/company/get_xero_tax_types/" + company);
    return result;
  }

  async get_xero_organisation_details(company) {
    let result = await api.get("/api/company/get_xero_organisations/" + company);
    return result;
  }

  async get_xero_bank_transactions(company) {
    let result = await api.get("/api/company/get_xero_bank_transactions/" + company);
    return result;
  }

  async get_xero_profit_and_loss(company) {
    let result = await api.get("/api/company/get_xero_profit_and_loss/" + company);
    return result;
  }

  async stripe_get_account_details(company) {
    let result = await api.get("/api/stripe/retrieve/" + company);
    return result;
  }

  async create_stripe_customer(company, customer_data) {
    let result = await api.post("/api/stripe/create_customer/" + company, customer_data);
    return result;
  }

  async get_stripe_products(company) {
    let result = await api.get("/api/stripe/get_products/" + company);
    return result;
  }

  async get_stripe_customer_subscription(company) {
    try {
      let result = await api.get("/api/stripe/get_customer/" + company);
      return result;
    } catch (error) {
      console.log("Error fetching stripe customer subscription:", error);
      return null;
    }
  }

  async create_setup_intent(company, email, tenant_id, customer_id) {
    let result = await api.post("/api/stripe/setup_intent/" + company, { email: email, tenant_id: tenant_id, company: company, customer_id: customer_id });
    return result;
  }

  async create_stripe_subscription(data, company) {
    let result = await api.post("/api/stripe/create_subscription/" + company, { data });
    this.save_company_settings(company, "stripe_subscribed", true);
    return result;
  }

  async update_stripe_subscription(data, company, subscriptionId) {
    let result = await api.post("/api/stripe/update_subscription/" + company, { data, subscriptionId });
    return result;
  }

  //cancels at end of period
  async cancel_stripe_subscription(subscriptionId, company) {
    let result = await api.post("/api/stripe/cancel_subscription/" + company, { subscriptionId: subscriptionId });
    return result;
  }

  async get_stripe_upcoming_invoice(company, data) {
    let result = await api.post("/api/stripe/upcoming_invoice/" + company, { data });
    return result;
  }

  async add_stripe_payment_method(company, paymentMethodId, customerId, subscriptionId) {
    let result = await api.post("/api/stripe/add_payment_method/" + company, { paymentMethodId: paymentMethodId, customerId: customerId, subscriptionId: subscriptionId });
    return result;
  }

  //this function does nothing becuase stripity stripe versioning needs to be updated
  async get_customers_payment_methods(company, customerId) {
    let result = await api.get("/api/stripe/list_payment_methods/" + company + "/" + customerId);
    return result;
  }

  //reactivates if user has cancelled but is still in period
  //this function only works if the user has not yet reached the end of period
  async reactivate_stripe_subscription(subscriptionId, company) {
    let result = await api.post("/api/stripe/reactivate_subscription/" + company, { subscriptionId: subscriptionId });
    return result;
  }

  async get_delivery_orders(company, todaysDate, yesterdaysDate) {
    let result = await api.get('/api/delivery/get_orders/' + company + '/' + '?start_key=["deliver", "' + yesterdaysDate + '"]&end_key=["deliver", "' + todaysDate + '"]');
    return result.rows;
  }

  async get_geo_settings(company) {
    let result = await api.get("/api/company/get_geo_settings/\"" + company + "\"");
    return result.rows[0];
  }
}

const api = new API();
export { api };
